var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editIcon",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.875,0H6.125C1.75,0,0,1.75,0,6.125v5.25C0,15.75,1.75,17.5,6.125,17.5h5.25c4.375,0,6.125-1.75,6.125-6.125V9.625",
    transform: "translate(621.75 253.75)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.867,1.112l-6.9,6.9A2.373,2.373,0,0,0,.395,9.162L.018,11.8a1.246,1.246,0,0,0,1.488,1.488l2.634-.376a2.451,2.451,0,0,0,1.155-.578l6.895-6.9c1.19-1.19,1.75-2.572,0-4.323S9.057-.078,7.867,1.112Z",
    transform: "translate(626.168 253.53)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0A6.251,6.251,0,0,0,4.323,4.323",
    transform: "translate(633.046 255.631)",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H21V21H0Z",
    transform: "translate(620 252)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.0b321c9563baa0cbcb9ac31748827657.svg";
export { ForwardRef as ReactComponent };